import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleTrackerApiService } from '../infra/api.service';
import {
  VehicleTrackerMovementFindAllParams,
  VehicleTrackerPosition,
  VehicleTrackerPositionFindAllParams,
  VehicleTrackerStatistics,
  VehicleTrackerStatisticsParams,
  VehicleTrackerSummary,
} from './type';

@Injectable({ providedIn: 'root', useClass: VehicleTrackerApiService })
export abstract class VehicleTrackerService {
  abstract findAllPositions(
    filter?: VehicleTrackerPositionFindAllParams,
  ): Observable<PaginatedResponse<VehicleTrackerPosition>>;

  abstract findPositionByChassis(
    chassis: string,
  ): Observable<VehicleTrackerPosition>;

  abstract findMovementsByChassis(
    chassis: string,
    filter?: VehicleTrackerMovementFindAllParams,
  ): Observable<PaginatedResponse<VehicleTrackerPosition>>;

  abstract getStatisticsByChassis(
    chassis: string,
    params: VehicleTrackerStatisticsParams,
  ): Observable<VehicleTrackerStatistics>;

  abstract getSummary(): Observable<VehicleTrackerSummary>;
}
